/* tslint:disable */
/* eslint-disable */
export enum LanguageEnum {
  English = 1,
  German = 2
}
